export const TERMS_VERSION = '2026-08-06';
export const PRIVACY_VERSION = '2026-08-06';

export type LegalPageKey = 'privacy' | 'terms' | 'account-deletion';

export interface LegalSection {
  heading: string;
  paragraphs: string[];
}

export interface LegalPage {
  title: string;
  updated: string;
  counselNotice?: string;
  sections: LegalSection[];
}

export const LEGAL_PAGES: Record<LegalPageKey, LegalPage> = {
  privacy: {
    title: 'Privacy notice',
    updated: PRIVACY_VERSION,
    sections: [
      {
        heading: 'Who controls your data',
        paragraphs: [
          'This demonstration trainer is operated for evaluation only. Ask the person who gave you access if you have a privacy question.',
        ],
      },
      {
        heading: 'Data we use',
        paragraphs: [
          'The trainer stores account details, study activity, test results, notes, and technical security logs so you can use the demo.',
        ],
      },
      {
        heading: 'Service providers',
        paragraphs: [
          'Sign-in and optional billing may use third-party processors. They handle that data under their own terms.',
        ],
      },
      {
        heading: 'Your choices and rights',
        paragraphs: [
          'You can update your profile, request a copy of your data, or schedule account deletion from My Profile.',
        ],
      },
    ],
  },
  terms: {
    title: 'Terms of service',
    updated: TERMS_VERSION,
    sections: [
      {
        heading: 'Using this trainer',
        paragraphs: [
          'This is independent aviation theory study software. It is not an authority, approved training organisation, or substitute for official material and instruction. Keep your sign-in secure and use the service lawfully.',
        ],
      },
      {
        heading: 'Demo access',
        paragraphs: [
          'This instance is a demonstration environment. Content and features can change. Do not treat it as a production training record.',
        ],
      },
      {
        heading: 'Availability and content',
        paragraphs: [
          'Question content and features can change as syllabi and the product evolve. Planned maintenance and faults can interrupt access.',
        ],
      },
    ],
  },
  'account-deletion': {
    title: 'Delete your account',
    updated: '2026-08-06',
    sections: [
      {
        heading: 'Delete from this trainer',
        paragraphs: [
          'Sign in, open My Profile, select Delete Account, and complete both confirmation steps. The app shows the scheduled deletion date and signs you out.',
        ],
      },
      {
        heading: 'Cancel a pending deletion',
        paragraphs: [
          'Sign in before the scheduled date, return to My Profile, and select Cancel deletion.',
        ],
      },
      {
        heading: 'If you cannot sign in',
        paragraphs: [
          'Ask the person who gave you this demo account. They can verify your identity before processing the request.',
        ],
      },
    ],
  },
};
